import { render, staticRenderFns } from "./UserInfo.vue?vue&type=template&id=434a5c3b&scoped=true&"
import script from "./UserInfo.vue?vue&type=script&lang=js&"
export * from "./UserInfo.vue?vue&type=script&lang=js&"
import style0 from "./UserInfo.vue?vue&type=style&index=0&lang=css&"
import style1 from "./UserInfo.vue?vue&type=style&index=1&id=434a5c3b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "434a5c3b",
  null
  
)

export default component.exports